/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Badge_DescriptionInputs */

const en_agent_authorization_badge_description = /** @type {(inputs: Agent_Authorization_Badge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free listings receive a nofollow link by default. After the badge is installed, deployed, and verified, the listing receives a dofollow link.`)
};

const zh_agent_authorization_badge_description = /** @type {(inputs: Agent_Authorization_Badge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费条目默认获得 nofollow 链接。徽章添加、部署并验证通过后，条目将获得 dofollow 链接。`)
};

/**
* | output |
* | --- |
* | "Free listings receive a nofollow link by default. After the badge is installed, deployed, and verified, the listing receives a dofollow link." |
*
* @param {Agent_Authorization_Badge_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_badge_description = /** @type {((inputs?: Agent_Authorization_Badge_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Badge_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_badge_description(inputs)
	return zh_agent_authorization_badge_description(inputs)
});
export { agent_authorization_badge_description as "agent.authorization.badge_description" }